const numbers = [
  "siteId",
  "productId",
  "scanId",
  "categoryId",
  "sentinelId",
  "departmentId",
  "regionId",
  "quantity",
  "hour",
];
const decimals = ["amount", "price"];

export const cleanObject = (object: any): { [k: string]: any } => {
  const cleaned: any = {};
  Object.keys(object).forEach((key) => {
    if (object[key] !== null && object[key] !== "" && object[key] !== "-") {
      cleaned[key] = object[key];
    }
  });

  return cleaned;
};

export const parseParams = (object: any) => {
  const parsed: any = {};
  const cleaned = cleanObject(object);
  Object.keys(cleaned).forEach((key: any) => {
    if (object[key] == undefined) {
      return;
    }

    if (numbers.includes(key) && object[key] !== null) {
      try {
        parsed[key] = parseInt(object[key]);
      } catch (e) {}
    } else if (decimals.includes(key)) {
      try {
        parsed[key] = parseFloat(object[key]);
      } catch (e) {}
    } else if (key === "search" && object[key].length < 1) {
    } else if (key !== "__typename") {
      parsed[key] = object[key];
    }
  });
  return parsed;
};

// export const parseSearchParams = (object: any) => {
//   const where: any = {};
//   const order: any = {};

//   const parsed: any = {};
//   object.forEach((value: any, key: any) => {
//     if (numbers.includes(key)) {
//       try {
//         parsed[key] = parseInt(value);
//       } catch (e) {}
//     } else if (decimals.includes(key)) {
//       try {
//         parsed[key] = parseFloat(value);
//       } catch (e) {}
//     } else if (value == "true" || value == "false") {
//       parsed[key] = value == "true" ? true : false;
//     } else if (key === "search" && value.length < 1) {
//     } else {
//       parsed[key] = value;
//     }
//   });

//   // split parsed into where and order objects, order when value is ASC or DESC
//   Object.keys(parsed).forEach((key: any) => {
//     if (key.startsWith("order")) {
//       const orderKey = key.split(".")[1];
//       order[orderKey] = parsed[key];
//     } else {
//       where[key] = parsed[key];
//     }
//   });

//   return { where, order };
// };

export const parseSearchParams = (object: any) => {
  const parsed: any = {};
  object.forEach((value: any, key: any) => {
    if (numbers.includes(key)) {
      try {
        parsed[key] = parseInt(value);
      } catch (e) {}
    } else if (decimals.includes(key)) {
      try {
        parsed[key] = parseFloat(value);
      } catch (e) {}
    } else if (value == "true" || value == "false") {
      parsed[key] = value == "true" ? true : false;
    } else if (key === "search" && value.length < 1) {
    } else {
      parsed[key] = value;
    }
  });

  return parsed;
};

export const stringifyObject = (object: any) => {
  return Object.keys(object)
    .map((key) => {
      return `${key}=${object[key]}`;
    })
    .join("&");
};
